import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				background: theme.palette.common.white
			},
			inputPhone: {
				"& > div > input": {
					color: theme.palette.grey[700],
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 16,
					width: 200,
					textAlign: "center"
				},
				borderBottom: `1px solid ${theme.palette.grey[800]}`,
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey[800]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey[800]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.grey[500],
					textAlign: "initial",
					marginLeft: 15
				}
			},
			inputPassword: {
				width: "100%",
				marginBottom: 30,
				"& > div > input": {
					color: theme.palette.grey[700],
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 16
				},
				borderBottom: `1px solid ${theme.palette.grey[800]}`,
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey[800]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey[800]}`
				},
				"& > div > .MuiSelect-select.MuiSelect-select": {
					color: theme.palette.grey[500],
					textAlign: "initial",
					marginLeft: 15
				}
			},
			inputError: {
				border: `1px solid ${theme.palette.error.main} !important`,
				borderRadius: "50px !important"
			},
			textRemeber: {
				color: theme.palette.primary.contrastText,
				fontSize: 16
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 20,
				fontWeight: 500,
				textAlign: "center",
				marginTop: 40,
				marginBottom: 10
			},
			textVerify: {
				fontSize: 16,
				color: theme.palette.grey[700],
				textAlign: "center"
			},
			rootForm: {
				padding: 15
			},
			mt15: {
				marginTop: 15
			},
			customCheckbox: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end"
			},
			checked: {
				color: `${theme.palette.secondary.main} !important`
			},
			iconContainer: {
				display: "none !important"
			},
			bodyBtnSubmit: {
				display: "flex",
				justifyContent: "center"
			},
			bodyPhone: {
				display: "flex",
				justifyContent: "center",
				padding: "0px 65px",
				flexWrap: "wrap",
				flexDirection: "column",
				alignContent: "center",
				marginBottom: 85
			},
			label: {
				width: 55,
				height: 3,
				borderRadius: 50
			},
			btnSubmit: {
				background: theme.palette.secondary.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "inherit",
				width: 167,
				height: 36,
				borderRadius: 6,
				"&:hover": {
					background: `${theme.palette.secondary.dark} !important`
				}
			},
			btnDefault: {
				color: theme.palette.secondary.main,
				fontSize: 16,
				textAlign: "center",
				marginTop: 30,
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			hotline: {
				marginTop: 75,
				color: "#BDBDBD",
				fontSize: 16,
				marginBottom: 10,
				textAlign: "center",
				"& > span": {
					color: theme.palette.secondary.main
				}
			},
			header: {
				display: "flex",
				alignItems: "center",
				width: "100%",
				justifyContent: "space-between",
				flexDirection: "row"
			},
			btnIcon: {
				padding: 15,
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			errors: {
				color: theme.palette.error.main,
				fontSize: 12,
				marginTop: 5
			},
			opt: {
				display: "flex",
				justifyContent: "center",
				flexWrap: "wrap",
				flexDirection: "column",
				alignContent: "center"
			},
			customReactCodeInput: {
				"&>input": {
					borderBottom: "1px solid #D7D7D7",
					borderTop: "1px solid #0000",
					borderRight: "1px solid #0000",
					borderLeft: "1px solid #0000",
					margin: 4,
					paddingLeft: 8,
					width: 54,
					height: 55,
					fontSize: 32,
					boxSizing: "border-box",
					color: theme.palette.grey[700],
					backgroundColor: theme.palette.common.white,
					textAlign: "center"
				}
			},
			resendCode: {
				color: theme.palette.secondary.main,
				fontSize: 14,
				textAlign: "center",
				marginTop: 20,
				marginBottom: 16,
				cursor: "pointer",
				"& > span": {
					color: theme.palette.grey[700]
				}
			}
		}),
	{
		name: "VerifyPage",
		index: 1
	}
);

export default useStyles;
